const BASE_URL = process.env.PURCHASE_API_URL;

export const REVIEW_ORDER_ENDPOINTS = {
  GET_REVIEW_SUMMARY: `${BASE_URL}/api/v1/review`,
  PLACE_ORDER: `${BASE_URL}/api/v1/place-order`,
  COMPLETE_REVIEW_ORDER: `${BASE_URL}/api/v1/review-order`,
  SELECT_VIN_ETCHING: `${BASE_URL}/api/v1/vinetching/select`,
  DECLINE_VIN_ETCHING: `${BASE_URL}/api/v1/vinetching/decline`
};
